/**
 * Ist das ein Emoji — und nichts sonst?
 *
 * **Dieselbe Regel wie in `server/src/Emoji.php`**, und das ist eine bewusste
 * Doppelung: der Server entscheidet, hier wird nur früher gesagt, was er
 * ohnehin abweisen würde. Ein Feld, das eine Absage erst nach der Leitung
 * bringt, fühlt sich kaputt an.
 *
 * `\p{Extended_Pictographic}` und Freunde brauchen `u`; alle Browser, die
 * diese Anwendung bedient, können das seit Jahren.
 */
const ERLAUBT =
  /^(\p{Extended_Pictographic}|\p{Emoji_Modifier}|\p{Emoji_Component}|\u200D|\uFE0F|\u20E3)+$/u

/**
 * Mindestens eines davon muss dabei sein — sonst käme „123" durch (Ziffern
 * sind für Unicode Emoji-Bestandteile, sie tragen die Tastenzeichen 1️⃣).
 *
 * **`Regional_Indicator` gehört dazu, und das war beinahe ein Fehler.** Eine
 * Landesfahne (🇩🇪) besteht aus zwei Regionsbuchstaben und enthält *kein*
 * Bildzeichen: ohne diese Zeile hätte der Browser sie abgewiesen, während der
 * Server sie annimmt — zwei Regeln, die auseinanderlaufen, genau das, was
 * diese Doppelung vermeiden soll. Beim Gegenlesen der beiden Listen
 * aufgefallen.
 */
const TRAEGT = /\p{Extended_Pictographic}|\p{Regional_Indicator}|\u20E3/u

/** Höchstens so viele Codepunkte — wie die Spalte und wie der Server. */
const HOECHSTENS = 16

export function istEmoji(text: string): boolean {
  const zeichen = text.trim()
  if (zeichen === '' || [...zeichen].length > HOECHSTENS) return false
  return ERLAUBT.test(zeichen) && TRAEGT.test(zeichen)
}
